require('./style.css');
var tmpl = require('./main.ejs');
var Events = require('f.core.event');

var ErrorBox = function (title) {
  this.title = title || '主播被风吹走了...';
  this.init();
};

ErrorBox.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

ErrorBox.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl({title: this.title});
  this.el = div.children[0];
  this.reload_btn = this.el.getElementsByClassName('l-error_btn')[0];
};

ErrorBox.prototype.initEvent = function () {
  var _this = this;
  this.el.addEventListener('touchend', function(e){
    _this.trigger('error_toggle');
    return false;
  })

  this.reload_btn.addEventListener('touchend', function(e){
    window.location.reload();
    e.preventDefault();
  }, false)
};

ErrorBox.prototype.hide = function () {
  this.el.style.visibility = 'hidden';
};

ErrorBox.prototype.show = function () {
  this.el.style.visibility = 'visible';
};

ErrorBox.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

ErrorBox.prototype.destory = function () {
  this.el.parentNode.removeChild(this.el);
};
Events.mixTo(ErrorBox);

module.exports = ErrorBox;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/error/index.js